__turbopack_context__.v({
  "member-card": "e1ursa_member-card",
  "member-card__badge": "e1ursa_member-card__badge",
  "member-card__company-name": "e1ursa_member-card__company-name",
  "member-card__designations": "e1ursa_member-card__designations",
  "member-card__details": "e1ursa_member-card__details",
  "member-card__level-label--sr-only": "e1ursa_member-card__level-label--sr-only",
  "member-card__name": "e1ursa_member-card__name",
  "member-card__photo": "e1ursa_member-card__photo",
  "member-card__photo-container": "e1ursa_member-card__photo-container",
});
